import React, { 
    useState, 
    useEffect,
    useCallback } from 'react';
import {
    Button,
    Form,
    Input,
    notification,
    Result,
    Checkbox
} from 'antd';
import MaskedInput from "antd-mask-input";
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import axios from 'axios';
import {
    CheckCircleOutlined,
    CloseCircleOutlined
} from '@ant-design/icons';

import CCTSLogo from '../../images/ccts-logo.png';

function ComplaintsMenu() {
    
    const [firstNameValidSuffix, setFirstNameValidSuffix] = useState(<></>);
    const [firstNameValid, setFirstNameValid] = useState(false);
    const [firstName, setFirstName] = useState('');

    const [lastNameValidSuffix, setLastNameValidSuffix] = useState(<></>);
    const [LastNameValid, setLastNameValid] = useState(false);
    const [lastName, setLastName] = useState('');

    const [emailValidSuffix, setEmailValidSuffix] = useState(<></>);
    const [emailValid, setEmailValid] = useState(false);
    const [email, setEmail] = useState('');

    const [phoneNumberValidSuffix, setPhoneNumberValidSuffix] = useState(<></>);
    const [phoneNumberValid, setPhoneNumberValid] = useState(false);
    const [phone, setPhone] = useState('');

    const [message, setMessage] = useState('');
    const [existingCustomer, setExistingCustomer] = useState(false);

    const [formSubmitting, setFormSubmitting] = useState(false);
    const [showForm, setShowForm] = useState(true);
    const [submissionResult, setSubmissionResult] = useState(<></>);

    const { executeRecaptcha } = useGoogleReCaptcha();
    const [form] = Form.useForm();
    const siteDomain = headerVars.siteDomain;

    const { TextArea } = Input;

    const [api, contextHolder] = notification.useNotification();

    const handleOnInputChange = ( e ) => {
        let currentVal = e.target.value;
        let inputID = e.target.id;
        validateInput( currentVal, inputID );
    }

    const handleCheckboxChange = ( e ) => {
        setExistingCustomer( e.target.checked )
    }

    const handleReCaptchaVerify = useCallback(async () => {
        if (!executeRecaptcha) {
          console.log('Execute recaptcha not yet available');
          return;
        }

        setFormSubmitting( true );

        const token = await executeRecaptcha('success');
        console.log("token: ", token);

        let form_data = new FormData;
        form_data.append('action', 'startca_handle_form_submissions');
        form_data.append('token', token);
        form_data.append('form', 'complaints');
        form_data.append('first_name', firstName);
        form_data.append('last_name', lastName);
        form_data.append('email', email);
        form_data.append('phone', phone);
        form_data.append('message', message);
        form_data.append('existing_customer', existingCustomer);

        let requestUrl = {ajax_url : siteDomain+"/wp-admin/admin-ajax.php"};

        axios
        .post(requestUrl.ajax_url, form_data)
        .then(function(response){
            console.log( 'response:: ', response.data );
            setFormSubmitting( false );

            switch( response.data ) {
                case 'sent-successfully':
                openNotification('topLeft', 'sales');
                setShowForm( false );
                setSubmissionResult( 
                    <Result
                        status="success"
                        title="Your message was received sucessfully!"
                        subTitle="A member of our Support team will be in touch with you shortly."
                        extra={[]}
                    />
                 );
                break;

                case 'failed-send':
                setShowForm( false );
                setSubmissionResult( 
                    <Result
                        status="error"
                        title="Submission failed!"
                        subTitle="There was a problem submitting your request. Please try again later."
                        extra={[]}
                    />
                 );
                break;
            }

        })
        .catch(function (error) {
            console.log(error);
            setSubmissionResult( 
                <Result
                    status="error"
                    title="Submission failed!"
                    subTitle="There was a problem submitting your request. Please try again later."
                    extra={[]}
                />
             );
        })
        .finally(function () {
            // always executed 
        });

    }, [executeRecaptcha,
        firstName,
        lastName,
        email,
        phone,
        message,
        existingCustomer,
        setFormSubmitting
    ]);

    const openNotification = ( placement, formName ) => {
        api.info({
            message: "Message Received!",
            description: "Thanks for reaching out! A member of our Support team will be in contact soon.",
            placement,
        });
    }

    const validateInput = ( currentVal, inputId ) => {
        let isValid = true;
        let validationSuffix = <></>;

        switch( inputId ) {
            case 'complaints-form-first-name': 
                if( currentVal.length < 2 ){ 
                    isValid = false;
                }

                validationSuffix = isValid ? <CheckCircleOutlined style={{ color: '#52C41A' }}/> : <CloseCircleOutlined style={{ color: '#ff4545' }}/>;

                let customerName = isValid ? currentVal : '';

                setFirstNameValid( isValid );
                setFirstName( customerName );
                setFirstNameValidSuffix( validationSuffix );

                //console.log("firstName: ", firstName);
                
                if( !isValid ) { }
            break;

            case 'complaints-form-last-name': 
                if( currentVal.length < 2 ){
                    isValid = false;
                }

                validationSuffix = isValid ? <CheckCircleOutlined style={{ color: '#52C41A' }}/> : <CloseCircleOutlined style={{ color: '#ff4545' }}/>;

                let customerLastName = isValid ? currentVal : '';

                setLastName( customerLastName );
                setLastNameValidSuffix( validationSuffix );
                setLastNameValid( isValid );

                if( !isValid ) { }
            break;

            case 'complaints-form-phone-number': 
                //console.log( "currentVal:: ", currentVal );
                if( !currentVal.match(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im) ) {
                    isValid = false;
                }

                validationSuffix = isValid ? <CheckCircleOutlined style={{ color: '#52C41A' }}/> : <CloseCircleOutlined style={{ color: '#ff4545' }}/>;

                let customerPhone = isValid ? currentVal : '';

                setPhone( currentVal );
                setPhoneNumberValidSuffix( validationSuffix );
                setPhoneNumberValid( isValid );

                if( !isValid ) { }
            break;

            case 'complaints-info-email':
                if( !currentVal.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) ) {
                    isValid = false;
                }

                validationSuffix = isValid ? <CheckCircleOutlined style={{ color: '#52C41A' }}/> : <CloseCircleOutlined style={{ color: '#ff4545' }}/>;

                let customerEmail = isValid ? currentVal : '';

                setEmail( customerEmail );
                setEmailValidSuffix( validationSuffix );
                setEmailValid( isValid );

                if( !isValid ) { }
            break;

            case 'complaints-message':
                setMessage( currentVal );
            break;
        }
    }

    const handleChangeServiceSelection = ( value ) => {
        setServiceSelection( value );
    }

    return (
        <div className='default-menu-items sales-menu-items'>
            <div className='support-links-container'>
                <h4>We value your feedback</h4>
                <p>We're here to address complaints promptly and find solutions that fit your needs.</p>

                <Form form={ form } style={{ 'display': ( showForm  ) ? 'block' : 'none' }} > 
                    <div className="form-column-row">
                        <Form.Item
                            label="First name"
                            labelCol={{ span: 24 }}
                            name="firstname"
                            style={{paddingRight:'1rem'}}
                            rules={[
                                {
                                required: false,
                                message: 'Please input your first name!',
                                },
                            ]}
                        >
                            <Input
                                id="complaints-form-first-name"
                                suffix={ firstNameValidSuffix }
                                autoFocus
                                onChange={handleOnInputChange}
                                defaultValue={ firstName }
                            />
                        </Form.Item>
                        <Form.Item
                            label="Last name"
                            labelCol={{ span: 24 }}
                            name="lastname"
                            rules={[
                                {
                                required: false,
                                message: 'Please input your last name!',
                                },
                            ]}
                        >
                            <Input
                                id="complaints-form-last-name"
                                suffix={ lastNameValidSuffix }
                                onChange={handleOnInputChange}
                                defaultValue={ lastName }
                            />
                        </Form.Item>
                    </div>
                    <div className="form-column-row">
                        <Form.Item
                            label="Email address"
                            name="emailaddress"
                            style={{paddingRight:'1rem'}}
                            labelCol={{ span: 24 }}
                            rules={[
                                {
                                required: false,
                                message: 'Please input your email!',
                                },
                            ]}
                        >
                            <Input 
                                id="complaints-info-email"
                                suffix={ emailValidSuffix }
                                onChange={handleOnInputChange}
                                defaultValue={ email }
                            />
                        </Form.Item>

                        <Form.Item
                            label="Phone number"
                            labelCol={{ span: 24 }}
                            name="phonenumber"
                            rules={[
                                {
                                required: false,
                                message: 'Please input your phone number!',
                                },
                            ]}
                        >
                            <MaskedInput
                                id="complaints-form-phone-number"
                                mask={'(000) 000-0000'}
                                suffix={ phoneNumberValidSuffix }
                                onChange={handleOnInputChange}
                                defaultValue={ phone }
                            />
                        </Form.Item>
                    </div>
                    <div className="form-column-row">
                        <Form.Item
                            label="Message"
                            name="message"
                            style={{paddingRight:'1rem',width:'100%'}}
                            labelCol={{ span: 24 }}
                            rules={[
                                {
                                required: false,
                                message: 'Please input a message!',
                                },
                            ]}
                        >
                            
                            <TextArea 
                                id="complaints-message"
                                rows={ 4 }
                                onChange={ handleOnInputChange }
                            />
                        </Form.Item>
                    </div>

                    <div className="form-column-row">
                        <Checkbox 
                            id="existing-customer"
                            style={{ marginBottom:'1.5rem' }}
                            onChange={ handleCheckboxChange }
                        >I'm an existing customer
                        </Checkbox>
                    </div>

                    <Button 
                        className='g-recaptcha'
                        onClick={ handleReCaptchaVerify }
                        loading={ formSubmitting }
                        type="primary"
                        disabled={ ( firstNameValid && LastNameValid && emailValid ) ? false : true }
                    >Submit</Button>

                    <div className='ccts-info-container'>
                        <img className="ccts-img" src={ CCTSLogo } alt="ccts-logo" />
                        <p>Commission for Complaints for Telecom-television Services (CCTS) CCTS is an independent agency whose mandate is to resolve complaints of consumers about their telecom and TV services, and complaints of small business customers about their telecom services, free of charge. If you have a complaint about your telephone, wireless, internet or TV service, you must first try to resolve it directly with your service provider. If you have done so and have been unable to reach a satisfactory resolution, CCTS may be able to help you. To learn more about CCTS, you may visit its website at www.ccts-cprst.ca or call toll-free at 1-888-221-1687.</p>
                    </div>
                </Form>
                { submissionResult }
            </div>
            { contextHolder }
        </div>
    )
}

export default ComplaintsMenu
